var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[(_vm.hasTopicMedia)?_c('div',{staticClass:"mt-4"},[_c('TopicMediaPreview',{attrs:{"doc-path":_vm.selectedTopics.docPath,"doc-type":_vm.selectedTopics.docType,"video-id":"video"},on:{"pause":_vm.getTime}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }